module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-330.92325d1.woff2";